import { AbsentStudentsListCtrl } from './absent-students-list.controller';

export const AbsentStudentsListComponent = {
  controller: AbsentStudentsListCtrl,
  bindings: {
    studentSupports$: '<',
    attendanceRecords: '<',
  },
  template: require('./absent-students-list.html'),
};
